// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Mz_H","productName":"Table_productName__3_lSJ"};